import React from 'react';
import { Button } from '../../ui/Button';
import { FileText } from 'lucide-react';
import { apiPost } from '../../../api/client';
import { toast } from 'sonner';

export function ContractStep() {
  const [seeding, setSeeding] = React.useState(false);

  const handleSeed = async () => {
    setSeeding(true);
    try {
      await apiPost('/contract-template/seed-default');
      toast.success('Template contratto predefinito creato');
    } catch {
      toast.error('Errore nella creazione del template');
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Crea un template contratto predefinito con le sezioni standard.
      </p>
      <Button onClick={handleSeed} loading={seeding} icon={<FileText size={14} />} style={{ alignSelf: 'flex-start' }}>
        Crea template contratto predefinito
      </Button>
      <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)' }}>
        Potrai personalizzarlo dopo da Impostazioni → Documenti Legali.
      </p>
    </div>
  );
}
